/* Dependencies
 ----------------------------------------------------------*/
import {Application} from "wrapper6";

/* Vendor
 ----------------------------------------------------------*/


/* Setup
 ----------------------------------------------------------*/
var app = window.app = new Application(window.options || {});

/* Services
 ----------------------------------------------------------*/


/* Register services
 ----------------------------------------------------------*/

/* Modules
 ----------------------------------------------------------*/
import Navigation from "modules/_navigation";
import ObjectFit from "modules/_object-fit";
import Print from "modules/_print";
import VideoModal from "./modules/_video-modal";
import InstagramFeed from "./modules/_instagram-feed";
import Slider from "./modules/_slider";
import GallerySlider from "./modules/_gallery-slider";
import Filters from "./modules/_filters";
import CoverSlider from "./modules/_cover-slider";
import DefaultCover from "./modules/_default-cover";
import NavSearch from "./modules/_nav-search";
import ContactTracking from "./modules/_contact-tracking";

/* Register modules
 ----------------------------------------------------------*/
app.use(Navigation);
app.use(ObjectFit);
app.use(Print);
app.use(VideoModal);
app.use(InstagramFeed);
app.use(Slider);
app.use(GallerySlider);
app.use(Filters);
app.use(CoverSlider);
app.use(DefaultCover);
app.use(NavSearch);
app.use(ContactTracking);

require('./app');